export const APP_NAME = 'NAF Inventory'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const TOKEN_KEY = 'token'

